import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Threshold from "./mailNotification/Threshold";
import Burst from "./mailNotification/Burst";
import Count from "./mailNotification/Count";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import { Paper, makeStyles } from "@material-ui/core";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import useGroupSetting from "Hooks/useGroupSetting";

import { message } from "constants/message";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
}));

export default function MailNotification() {
  const messages = message();
  const groupSetting = useGroupSetting();
  const state = groupSetting.state;
  let alert_address = state.alert_address ? 
    state.alert_address.replace(/,/g, '\n') :
    "";
  const classes = useStyles();

  ValidatorForm.addValidationRule('checkAddresses', (value) => {
    let addressValidation = true;

    // メールアドレスの正規表現
    const regexp = /^((([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([A-Za-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([A-Za-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/;
    // 文字列を改行区切りで配列に入れる
    const addresses = value.split('\n');

    addresses.some(address => {
      if (address || address != "") {
        // メールアドレス形式チェック
        if (!regexp.test(address)) {
          addressValidation = false;
          return true;
        }
      }
    });
    return addressValidation;
  });

  return (
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom>
        メール通知条件
      </Typography>
      <Grid>
        <Grid item xs={12}>
          <RadioGroup
            aria-label="notice"
            name="notice"
            onChange={(event) => {
              groupSetting.setData("alert_type", event.target.value);
            }}
            value={state.alert_type}
          >
            <FormControlLabel
              value="none"
              control={<Radio />}
              label="通知を行わない"
            />
            <FormControlLabel
              value="burst"
              control={<Radio />}
              label="バーストを検知したら通知する"
            />
            <FormControlLabel
              value="threshold"
              control={<Radio />}
              label="累積収集件数で通知する"
            />
            <FormControlLabel
              value="count"
              control={<Radio />}
              label="時間あたりの収集件数で通知する"
            />
          </RadioGroup>
        </Grid>

        {state.alert_type !== "none" && (
          <Grid item>
            <Paper className={classes.paper} elevation={3}>
              {state.alert_type === "threshold" && (
                <Threshold
                  state={state}
                  onChangeThold={(event) =>
                    groupSetting.setData("thold", event.target.value)
                  }
                  onChangeInterval={(event) =>
                    groupSetting.setData("interval", event.target.value)
                  }
                />
              )}
              {state.alert_type === "burst" && (
                <Burst
                  state={state}
                  onChangeUnit={(event) => {
                    groupSetting.setData("unit", event.target.value);
                  }}
                  onChangeTarget={(event) => {
                    groupSetting.setData("target", event.target.value);
                  }}
                  onChangeRatio={(event) => {
                    groupSetting.setData("ratio", event.target.value);
                  }}
                />
              )}
              {state.alert_type === "count" && (
                <Count
                  state={state}
                  onChangeUnit={(event) => {
                    groupSetting.setData("unit", event.target.value);
                  }}
                  onChangeThold={(event) =>
                    groupSetting.setData("thold", event.target.value)
                  }
                  onChangeInterval={(event) =>
                    groupSetting.setData("interval", event.target.value)
                  }
                />
              )}
              <Grid container spacing={3}>
                <Grid item xs={2}>
                  <Typography value="h6">対象記事</Typography>
                </Grid>
                <Grid item xs={10}>
                  <RadioGroup
                    row
                    aria-label="position"
                    name="position"
                    defaultValue="top"
                    onChange={(event) => {
                      groupSetting.setData("alert_target", event.target.value);
                    }}
                    value={state.alert_target}
                  >
                    <FormControlLabel
                      value="all"
                      control={<Radio color="primary" />}
                      label="全て"
                    />
                    <FormControlLabel
                      value="positive"
                      control={<Radio color="primary" />}
                      label="ポジティブ"
                    />
                    <FormControlLabel
                      value="negative"
                      control={<Radio color="primary" />}
                      label="ネガティブ"
                    />
                  </RadioGroup>
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="is_alert_tweets"
                        color="primary"
                        onChange={(event) => {
                          groupSetting.setData(
                            "is_alert_tweets",
                            event.target.checked
                          );
                        }}
                        checked={state.is_alert_tweets}
                      />
                    }
                    label="投稿内容をメールに記載する"
                  />
                  <FormControl>
                    <Select
                      native
                      onChange={(event) => {
                        groupSetting.setData(
                          "alert_tweets",
                          event.target.value
                        );
                      }}
                      value={state.alert_tweets ? state.alert_tweets : 
                        groupSetting.setData("alert_tweets", 30)}
                      disabled={ !state.is_alert_tweets }
                    >
                      <option value={10}>10</option>
                      <option value={15}>15</option>
                      <option value={20}>20</option>
                      <option value={25}>25</option>
                      <option value={30}>30</option>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        )}
        <Grid item>
          <TextValidator
            label="送信先"
            multiline
            fullWidth
            minRows={3}
            maxRows={3}
            value={alert_address}
            onChange={(event) =>
              groupSetting.setData("alert_address", event.target.value)
            }
            validators={['checkAddresses']}
            errorMessages={[messages.validation.isEmail]}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
